import "./App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import { DataProvider } from "./context/DataContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import News from "./components/News";
import Publications from "./components/Publications";
import Awards from "./components/Awards";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Navbar />
        <main className="page">
          <DataProvider>
            <Hero />
            <News />
            <Publications />
            <Awards />
            <Contact />
          </DataProvider>
        </main>
        <Footer />
      </LanguageProvider>
    </ThemeProvider>
  );
}
